import React from "react";
import { CSSTransitionGroup, CSSTransition } from "react-transition-group";
import download from "downloadjs";
import { createForm, formShape } from "rc-form";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-grid-system";
import Modal from "../Common/Modal";
import NewModal from "../Common/Modal";
import Button from "../Common/Buttons/ButtonPrimary";
import axios from "../../lib/axios-client";
import httpClient from "../../lib/HttpClient";
import history from "../../history";
import notificationService from "../../services/Notifications";
import moment from "moment";

import Pindrop from "../../images/icons/svg/pindrop.svg";
import externalLinkGreen from "../../images/icons/svg/export-teel.svg";
import AnnotationLayersIcon from "../../images/icons/svg/annotation-layers-inverted.svg";

import security from "../../services/Security";

import styles from "./ReferenceViewer.module.scss";

/* UI Kit */
import {
  UikFormInputGroup,
  UikInput,
  UikButton,
  UikHeadline,
  UikDivider,
  UikDropdown,
  UikDropdownItem,
  Uikon,
  UikToggle,
} from "@uik";
import "@uik/styles.css";
import "../../font.scss";

/* Papercurve Components */
import Header from "../shared/Header/Header";
import Reference from "./Reference";
import PDFTReference from "./PDFTReference";
import RefPanel from "./RefPanel";
import closeSVG from "../../images/icons/svg/close.svg";
import linkSVG from "../../images/icons/svg/link-grey.svg";
import defaultTooltipSVG from "../../images/icons/svg/info-tooltip-default.svg";
import activeTooltipSVG from "../../images/icons/svg/info-tooltip-active.svg";
import dimpleSVG from "../../images/icons/svg/toolbox-dimple.svg";
import dimpleSVGBlue from "../../images/icons/svg/toolbox-dimple-blue.svg";
import moreIcon from "../../images/icons/more.svg";
import chatIcon from "../../images/icons/svg/icon_chat.svg";
import Chats from "./Panels/Chats";
import "./ReferencePanelAnimation.css";

class ReferenceViewerBuild extends React.Component {
  constructor(props) {
    super();

    this.chatCitationHighlight = null;
    this.chatCitationTimeout = null;

    this.state = {
      document: {},
      renameModalOpen: false,
      documentLoaded: false,
      selectedBlockId: null,
      conversationBlockId: null,
      referenceBlockId: null,
      referenceTextCaption: null,
      existingReferenceBlockId: null,
      conversationPageNumber: null,
      currentUser: {
        id: security.getUserId(),
        role: security.getUserRole(),
      },
      confirm_disabled: false,
      currentXfdfHighlightPageIndex: null,
      currentXfdfHighlightId: null,
      currentXfdfHighlightString: null,
      currentXfdfHighlightTextCaption: null,
      searchValue: "",
      references: null,
      sharedReferences: null,
      showRenameModal: false,
      showDeleteModal: false,
      showDescription: false,
      currentRefLabel: null,
      hideOutsideAnnots: true,
      hideReferenceAnnotations: false,
      tracingReference: false,
      tracedReferenceId: null,
      // Chat panel state
      chatsPanelOpen: false,
      currentChatSessionId: null,
    };
  }

  addReferenceStampImage = (xfdfHighlightString) => {
    const stampImageTag = /<imagedata>([^>]*)<\/imagedata>/;
    const xfdfWithStampImages = xfdfHighlightString.replace(
      stampImageTag,
      "<imagedata>data:image/svg+xml;base64,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</imagedata>"
    );

    return xfdfWithStampImages;
  };

  addStampImageToPinReferences = (references) => {
    const referencesWithStamps = references.map((reference) => {
      reference.xfdf_highlight_string = this.addReferenceStampImage(
        reference.xfdf_highlight_string
      );

      return reference;
    });

    return referencesWithStamps;
  };

  componentWillMount = () => {
    const docId = this.props.match.params.id;
    const readOnly =
      this.props.location.state !== undefined &&
      this.props.location.state.readOnly
        ? true
        : false;
    if (!this.state.documentLoaded) {
      httpClient.get(`/documents/${docId}.json`).then((response) => {
        this.setState({
          document: response.data,
          readOnly: readOnly,
          documentTitleInputValue: response.data.title,
          documentDescriptionInputValue: response.data.description,
          referenceDocumentLabel: response.data.reference_document_label,
        });
        httpClient
          .get(`/references_library/${response.data.library_id}.json`)
          .then((res) => {
            this.setState({
              sharedReferences: res.data,
            });
          });
        httpClient
          .get(`/documents/${response.data.id}/document_references.json`)
          .then((res) => {
            this.setState({
              references: this.addStampImageToPinReferences(res.data),
              filteredReferences: res.data,
            });
          });
      });
    }
  };

  handleDownload = () => {
    const token = security.getToken();

    const _that = this;
    axios({
      method: "get",
      url: `/documents/${this.state.document.id}/file`,
      responseType: "arraybuffer",
      headers: { Authorization: `Bearer ${token}` },
    }).then(function (response) {
      const content = response.headers["content-type"];
      download(
        response.data,
        `${_that.state.document.title}.${_that.state.document.file_extension}`,
        `${_that.state.document.mime_type}`
      );
    });
  };

  handleDelete = (e) => {
    e.preventDefault();
    const token = security.getToken();
    const docId = this.props.match.params.id;

    const confirmed = window.confirm(
      `Are you sure you want to delete ${this.state.document.title} ?`
    );

    if (confirmed) {
      httpClient.delete(`/documents/${docId}.json`).then((response) => {
        console.log("deleted!");
        history.push("/dashboard");
      });
    }
  };

  deleteReferenceAnnotation = (refId, count) => {
    if (count === 0) {
      httpClient.delete(`/references/${refId}.json`).then(() => {
        if (this.state.currentXfdfHighlightId) {
          const webViewerEl = document.getElementById("webViewer");
          const annotationManager =
            window.WebViewer.getInstance(webViewerEl).Core.annotationManager;
          const annot = annotationManager.getAnnotationById(
            this.state.currentXfdfHighlightId
          );

          annotationManager.deleteAnnotation(annot);
        }
        let refArray = this.state.references;
        let refIndex;

        refArray.map((ref, index) => {
          if (ref.id === refId) {
            refIndex = index;
          }
        });
        refArray.splice(refIndex, 1);
        this.setState({
          references: refArray,
          currentRefLabel: null,
        });
        notificationService.addNotification(
          "Annotation has been deleted",
          "This Annotation has been successfully deleted",
          "success"
        );
      });
    } else {
      notificationService.addNotification(
        "Unable to delete annotation",
        "Annotations linked to a document cannot be deleted",
        "warning"
      );
    }
  };

  onHighlightedBlock = (blockId, caption) => {
    console.log(caption);
    this.setState({
      referenceBlockId: blockId,
      referencePageNumber: blockId.split("-")[2],
      referenceTextCaption: caption,
    });
  };

  onClickedReferenceIndicator = (e) => {
    this.setState({
      referenceBlockId: e,
      referencePageNumber: e.split("-")[2],
    });
  };

  onReferenceSelection = () => {
    const blockId = this.state.selectedBlockId;
    const unhighlightElements = document.getElementsByClassName(
      "selectedDocumentText"
    );

    this.setState({
      selectedBlockId: null,
      referenceBlockId: blockId,
      referencePageNumber: blockId.split("-")[2],
    });

    while (unhighlightElements[0]) {
      unhighlightElements[0].classList.add("referencedText");
      unhighlightElements[0].classList.remove("selectedDocumentText");
    }
  };

  onCloseRefPanel = (e) => {
    const unhighlightElements =
      document.getElementsByClassName("referencedText");

    while (unhighlightElements[0]) {
      unhighlightElements[0].classList.remove("referencedText");
    }

    this.setState({
      referenceBlockId: null,
      referenceTextCaption: null,
    });
  };

  addReference = () => {
    this.legacyAddReference();
  };

  legacyAddReference = () => {
    this.setState({ confirm_disabled: true });

    const documentBlockId = this.props.match.params.blockIdentifier;
    const referenceBlockId = this.state.referenceBlockId;
    const pageNumber = this.state.referencePageNumber;
    const docId = this.state.document.id;
    const parentDocId = this.state.document.reference_document_id;
    const referenceTextCaption = this.state.referenceTextCaption;

    const parentDocPageNumber = documentBlockId.split("-")[2];

    const referenceData = {
      reference: {
        document_id: parseInt(docId),
        page_number: parseInt(pageNumber),
        block_identifier: referenceBlockId,
        caption: referenceTextCaption,
      },
      document_reference: {
        document_id: parseInt(parentDocId),
        page_number: parseInt(parentDocPageNumber),
        block_identifier: documentBlockId,
      },
    };

    httpClient
      .post("/references.json", referenceData)
      .then((response) => {
        history.push(`/drafts/${this.state.document.reference_document_id}`);
        this.setState({ confirm_disabled: false });
      })
      .catch((e) => {
        this.setState({ confirm_disabled: false });
      });
  };

  onAddReference = (
    pageIndex,
    annotationId,
    annotationXfdfString,
    annotationText,
    referenceLabel,
    referenceDocumentLabel
  ) => {
    if (this.props.match.params.library) {
      this.onAddSingleReference(
        pageIndex,
        annotationId,
        annotationXfdfString,
        annotationText,
        referenceLabel,
        referenceDocumentLabel
      );
      this.setState({ currentRefLabel: referenceLabel });
    } else {
      // There can be a Reference object already.
      this.setState({ confirm_disabled: true });

      // These are retrieving the localstorage stored data for the parent document.
      const annotationHighlightXfdfId = localStorage.getItem(
        "annotationHighlightXfdfId"
      );
      const parentAnnotationHighlightXfdfPageNumber = localStorage.getItem(
        "parentAnnotationHighlightXfdfPageNumber"
      );
      const documentReferenceCaption = localStorage.getItem(
        "currentAnnotationText"
      );
      const annotationHighlightXfdf = localStorage.getItem(
        annotationHighlightXfdfId
      );
      const parentDocId = localStorage.getItem("parentDocumentId");

      const referenceData = {
        reference: {
          document_id: parseInt(this.state.document.id),
          page_number: parseInt(pageIndex),
          xfdf_highlight_id: annotationId,
          xfdf_highlight_string: this.removePinStampImage(annotationXfdfString),
          caption: annotationText,
          label: referenceLabel,
        },
        document_reference: {
          document_id: parseInt(parentDocId),
          page_number: parseInt(parentAnnotationHighlightXfdfPageNumber),
          xfdf_highlight_id: annotationHighlightXfdfId,
          xfdf_highlight_string: this.removePinStampImage(
            this.props.location.state.parentDocumentReferenceXFDF
              ? this.props.location.state.parentDocumentReferenceXFDF
              : annotationHighlightXfdf
          ),
          caption: documentReferenceCaption,
        },
        reference_document: {
          reference_document_label: referenceDocumentLabel,
        },
      };

      httpClient
        .post("/references.json", referenceData)
        .then((response) => {
          history.push({
            pathname: `/drafts/${parentDocId}`,
            search: `?xfdfId=${annotationHighlightXfdfId}`,
            state: {
              newAnnotationAdded: true,
            },
          });
          this.setState({ confirm_disabled: false });
        })
        .catch((e) => {
          this.setState({ confirm_disabled: false });
        });
    }
  };

  removePinStampImage = (xfdfHighlightString) => {
    const pinStampImage = /<imagedata>([^>]*)<\/imagedata>/g;
    const xfdfWithoutPinStampImage = xfdfHighlightString.replace(
      pinStampImage,
      "<imagedata></imagedata>"
    );
    return xfdfWithoutPinStampImage;
  };

  startTracingReference = (referenceId) => {
    this.setState({
      tracingReference: true,
      tracedReferenceId: referenceId,
    });
  };

  stopTracingReference = () => {
    this.setState({
      tracingReference: false,
      tracedReferenceId: null,
    });
  };

  // Chat panel handlers
  openChatsPanel = () => {
    this.setState({ chatsPanelOpen: true });
  };

  closeChatsPanel = () => {
    this.setState({ chatsPanelOpen: false });
  };

  handleChatSessionChange = (sessionId) => {
    this.setState({ currentChatSessionId: sessionId });
  };

  handlePaigeStatusChange = (newStatus) => {
    this.setState({
      document: {
        ...this.state.document,
        paige_status: newStatus,
      },
    });
  };

  handleChatCitationClick = (citationData) => {
    if (!citationData || !citationData.page) return;

    const page = citationData.page;
    const text = citationData.text;

    // Get WebViewer instance
    const webViewerEl = document.getElementById("annotblock");
    if (!webViewerEl) return;

    const instance = window.WebViewer.getInstance(webViewerEl);
    if (!instance) return;

    const documentViewer = instance.Core.documentViewer;

    // Navigate to the page
    documentViewer.setCurrentPage(page.page_number);

    // If we have citation text, search for it and underline
    if (text) {
      // Clear any existing citation highlight
      if (this.chatCitationHighlight) {
        const annotationManager = instance.Core.annotationManager;
        annotationManager.deleteAnnotation(this.chatCitationHighlight);
        this.chatCitationHighlight = null;
      }

      // Clear any existing timeout
      if (this.chatCitationTimeout) {
        clearTimeout(this.chatCitationTimeout);
      }

      // Search for the text and add underline
      instance.Core.documentViewer.textSearchInit(
        text,
        instance.Core.Search.Mode.PAGE_STOP,
        {
          fullSearch: false,
          onResult: (result) => {
            if (result.resultCode === instance.Core.Search.ResultCode.FOUND) {
              const annotationManager = instance.Core.annotationManager;
              const quads = result.quads;
              const pageNum = result.pageNum;

              // Create underline annotation
              const underline =
                new instance.Core.Annotations.TextUnderlineAnnotation();
              underline.PageNumber = pageNum;
              underline.Quads = quads.map(function (quad) {
                return new instance.Core.Math.Quad(
                  quad.x1,
                  quad.y1,
                  quad.x2,
                  quad.y2,
                  quad.x3,
                  quad.y3,
                  quad.x4,
                  quad.y4
                );
              });
              underline.StrokeColor = new instance.Core.Annotations.Color(
                255,
                0,
                0
              );
              underline.ReadOnly = true;

              annotationManager.addAnnotation(underline);
              annotationManager.redrawAnnotation(underline);

              this.chatCitationHighlight = underline;

              // Remove after 5 seconds
              this.chatCitationTimeout = setTimeout(() => {
                if (this.chatCitationHighlight) {
                  annotationManager.deleteAnnotation(
                    this.chatCitationHighlight
                  );
                  this.chatCitationHighlight = null;
                }
              }, 5000);
            }
          },
        }
      );
    }
  };

  onAddSingleReference = (
    pageIndex,
    annotationId,
    annotationXfdfString,
    annotationText,
    referenceLabel,
    referenceDocumentLabel
  ) => {
    // There can be a Reference object already.
    this.setState({ confirm_disabled: true });

    const referenceData = {
      reference: {
        document_id: parseInt(this.state.document.id),
        page_number: parseInt(pageIndex),
        xfdf_highlight_id: annotationId,
        xfdf_highlight_string: this.removePinStampImage(annotationXfdfString),
        caption: annotationText,
        label: referenceLabel,
      },
      document_reference: { document_id: 0 },
      reference_document: {
        reference_document_label: referenceDocumentLabel,
      },
    };

    let references = this.state.references;
    if (!references.find((ref) => ref.xfdf_highlight_id == annotationId)) {
      httpClient
        .post("/references.json", referenceData)
        .then((response) => {
          this.setState({ confirm_disabled: false });
          if (!response.data.document.reference_document_label) {
            response.data.document.reference_document_label =
              referenceDocumentLabel;
          }
          // Update the reference list
          references.push(response.data);
          this.setState({
            references: references,
            filteredReferences: references,
          });
        })
        .catch((e) => {
          this.setState({ confirm_disabled: false });
        });
    }
  };

  onUpdateReferenceLabel = (
    referenceId,
    referenceLabel,
    referenceDocumentLabel
  ) => {
    // There can be a Reference object already.
    this.setState({ confirm_disabled: true });

    const referenceData = {
      reference: {
        id: referenceId,
        label: referenceLabel,
      },
      reference_document: {
        reference_document_label: referenceDocumentLabel,
      },
    };

    httpClient
      .put(`/references/${referenceId}.json`, referenceData)
      .then((response) => {
        this.setState({ confirm_disabled: false });
        httpClient
          .get(
            `/documents/${this.props.match.params.id}/document_references.json`
          )
          .then((res) => {
            this.setState({
              references: res.data,
              filteredReferences: res.data,
            });
          });
      })
      .catch((e) => {
        this.setState({ confirm_disabled: false });
      });
  };

  onAnnotationSelect = (pageIndex, xfdfHighlightId) => {
    this.setState({
      referenceBlockId: null,
      referenceTextCaption: null,
      currentXfdfHighlightPageIndex: pageIndex,
      currentXfdfHighlightId: xfdfHighlightId,
    });
  };

  onAnnotationDeselect = () => {
    this.setState({
      referenceBlockId: null,
      referenceTextCaption: null,
      currentXfdfHighlightTextCaption: null,
      currentXfdfHighlightPageIndex: null,
      currentXfdfHighlightId: null,
    });
  };

  onTextSelection = (
    pageIndex,
    currentXfdfHighlightId,
    currentXfdfHighlightString,
    currentXfdfHighlightText
  ) => {
    // This should be passed to (PDFTron) <PDFTReference onTextSelection={this.onTextSelection} />
    // It gets trigger after text selection occurs in PDFTron's WebViewer.
    // We want to retrieve the `currentXfdf*` and utilize them to pin a reference highlight.

    if (currentXfdfHighlightId) {
      this.setState({
        currentXfdfHighlightPageIndex: pageIndex,
        currentXfdfHighlightId: currentXfdfHighlightId,
        currentXfdfHighlightString: currentXfdfHighlightString,
        currentXfdfHighlightTextCaption: currentXfdfHighlightText,
      });
    }
  };

  onCancelReference = () => {
    if (this.props.location.state && this.props.location.state.backTo) {
      this.props.history.push(this.props.location.state.backTo);
    } else {
      if (this.props.match.params.library == "library") {
        this.props.history.push({
          pathname: `/libraries/${this.state.document.library_id}/references`,
        });
      } else {
        let documentPath = "drafts";

        if (this.props.location.state && this.props.location.state.isApproved) {
          documentPath = "documents";
        }

        if (
          this.props.location.state &&
          this.props.location.state.originalDocumentId
        ) {
          this.props.history.push({
            pathname: `/${documentPath}/${this.props.location.state.originalDocumentId}`,
            state: {
              versionId: this.props.location.state.versionId,
              versionNumber: this.props.location.state.versionNumber,
            },
          });
        } else {
          const parentDocId = localStorage.getItem("parentDocumentId");

          this.props.history.push({
            pathname: `/drafts/${parentDocId}`,
          });
        }
      }
    }
  };

  onSearchChange = (e) => {
    const searchValue = e.target.value;
    const filteredReferences = this.state.references.filter(
      (reference) =>
        reference.caption &&
        reference.caption.toLowerCase().includes(searchValue.toLowerCase())
    );

    this.setState({
      searchValue,
      filteredReferences,
    });
  };

  viewContent = (documentReference) => {
    if (documentReference.document_approved) {
      window.open(
        `/documents/${documentReference.document_id}?xfdfId=${documentReference.xfdf_highlight_id}`
      );
    } else {
      window.open(
        `/drafts/${documentReference.document_id}?xfdfId=${documentReference.xfdf_highlight_id}`
      );
    }
  };

  renderDocumentName = (documentReference) => {
    let userCanAccessMainDoc = documentReference.current_user_can_access;
    if (userCanAccessMainDoc) {
      return (
        <div className={styles.nameContainer}>
          <img className={styles.linkImage} src={externalLinkGreen} />
          <td
            className={styles.docName}
            onClick={() => {
              this.viewContent(documentReference);
            }}
          >
            {documentReference.document_name}
          </td>
        </div>
      );
    } else {
      return (
        <td className={styles.docNameGray}>
          {documentReference.document_name}
        </td>
      );
    }
  };

  renderLinkedAnnotationsTable = (itemFields) => {
    return (
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <colgroup>
            <col key={0} span="1" className={styles.colLarge} />
            <col key={1} span="1" className={styles.col} />
          </colgroup>
          <thead>
            <tr
              className={
                itemFields.length > 4
                  ? styles.traceabilityHeaderContainerScroll
                  : styles.traceabilityHeaderContainer
              }
            >
              <td className={styles.nameColumn}>Name</td>
              <td className={styles.dateColumn}>Upload Date</td>
            </tr>
          </thead>
          <tbody>
            {itemFields.map((item, index) => (
              <tr>
                <td className={styles.colLarge}>
                  {this.renderDocumentName(item)}
                </td>
                <td className={styles.docUploadDate}>
                  {moment(item.document_upload_date).format("MMM Do YYYY")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  renderLinkedAnnotationsList = () => {
    const selectedReference = this.state.references.find((ref) => {
      return ref.id === this.state.tracedReferenceId;
    });
    return this.renderLinkedAnnotationsTable(
      selectedReference.document_references
    );
  };

  referenceClicked = (ref) => {
    const webViewerEl = document.getElementById("webViewerReference");
    const instance = window.WebViewer.getInstance(webViewerEl);
    const annotation = instance.Core.annotationManager.getAnnotationById(
      ref.xfdf_highlight_id
    );

    instance.Core.annotationManager.deselectAllAnnotations();
    instance.Core.annotationManager.selectAnnotation(annotation);
    instance.Core.documentViewer.setCurrentPage(ref.page.page_number);
  };

  onRenameSave = () => {
    httpClient
      .put(`/documents/${this.state.document.id}.json`, {
        title: this.state.documentTitleInputValue,
        description: this.state.documentDescriptionInputValue,
      })
      .then((res) => {
        this.setState({
          document: {
            ...this.state.document,
            title: res.data.title,
            description: res.data.description,
          },
          documentTitleInputValue: res.data.title,
          description: res.data.description,
          showRenameModal: false,
        });
      });
  };

  deleteReference = () => {
    httpClient.delete(`/documents/${this.state.document.id}`).then((res) => {
      this.onCancelReference();
    });
  };

  hideOutsideAnnotations = () => {
    if (this.state.hideOutsideAnnots) {
      this.setState({ hideOutsideAnnots: false });
    } else {
      this.setState({ hideOutsideAnnots: true });
    }
  };

  hideReferenceAnnots = () => {
    if (this.state.hideReferenceAnnotations) {
      this.setState({ hideReferenceAnnotations: false });
    } else {
      this.setState({ hideReferenceAnnotations: true });
    }
  };

  highlightSearchTerm = (text, highlight) => {
    // Split on highlight term and include term into parts, ignore case
    const parts = text ? text.split(new RegExp(`(${highlight})`, "gi")) : [];
    return (
      <span>
        {" "}
        {parts.map((part, i) => (
          <span
            key={i}
            className={
              part.toLowerCase() === highlight.toLowerCase()
                ? styles.highlight
                : {}
            }
          >
            {part}
          </span>
        ))}{" "}
      </span>
    );
  };

  renderReferencesList = () => {
    let referencesHT = {};
    if (this.state.filteredReferences) {
      this.state.filteredReferences.forEach((ref) => {
        if (!referencesHT[ref.page.page_number]) {
          referencesHT[ref.page.page_number] = [];
        }
        referencesHT[ref.page.page_number].push(ref);
      });
      const actionsDropDown = ({ onClick }) => {
        return (
          <span onClick={onClick}>
            <img className={styles.moreIcon} src={moreIcon} />
          </span>
        );
      };
      return (
        <div>
          {Object.entries(referencesHT).map(([key, refArr], index) => (
            <div key={index}>
              <div className={styles.pageNumber}>Page {key}</div>
              <div className={styles.dividerContainer} />
              <div>
                {refArr.map((ref) => (
                  <div className={styles.referenceCard}>
                    <div onClick={() => this.referenceClicked(ref)}>
                      <div className={styles.attachmentReferenceIdContainer}>
                        <div
                          className={
                            ref.document.reference_document_label && ref.label
                              ? styles.attachmentReferenceId
                              : styles.emptyAttachmentReferenceId
                          }
                        >
                          {ref.document.reference_document_label &&
                            ref.label && (
                              <div className={styles.referenceDocumentLabel}>
                                {ref.document.reference_document_label}
                              </div>
                            )}
                          {ref.document.reference_document_label &&
                          ref.label ? (
                            <div className={styles.referenceLabel}>
                              | {ref.label}
                            </div>
                          ) : (
                            "No Label"
                          )}
                          <div className={styles.fullLabelsContainer}>
                            <div className={styles.fullLabels}>
                              {`${
                                ref.document.reference_document_label &&
                                ref.label &&
                                ref.document.reference_document_label
                              } ${
                                ref.document.reference_document_label &&
                                ref.label
                                  ? `| ${ref.label}`
                                  : "No Label"
                              }`}
                            </div>
                            <div className={styles.bottomArrow} />
                          </div>
                        </div>
                        {security.getUserRole() !== "viewer" && (
                          <div
                            className={styles.referenceActionsDropDownContainer}
                          >
                            <UikDropdown
                              DisplayComponent={actionsDropDown}
                              position="bottomRight"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <UikDropdownItem
                                onClick={() =>
                                  this.deleteReferenceAnnotation(
                                    ref.id,
                                    ref.document_references.length
                                  )
                                }
                              >
                                Delete
                              </UikDropdownItem>
                              <UikDropdownItem
                                onClick={() => this.referenceClicked(ref)}
                              >
                                Edit
                              </UikDropdownItem>
                            </UikDropdown>
                          </div>
                        )}
                      </div>
                      {ref.caption === "Pindrop Reference" && (
                        <div className={styles.pindropCaptionContainer}>
                          <img className={styles.pinIcon} src={Pindrop} />
                          <div className={styles.pinReferenceCaption}>
                            {this.highlightSearchTerm(
                              ref.caption,
                              this.state.searchValue
                            )}
                          </div>
                        </div>
                      )}
                      {ref.caption !== "Pindrop Reference" && (
                        <div className={styles.captionContainer}>
                          <div className={styles.referenceCaption}>
                            {this.highlightSearchTerm(
                              ref.caption,
                              this.state.searchValue
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                    <div
                      onClick={() => {
                        ref.document_references.length > 0 &&
                          this.startTracingReference(ref.id);
                      }}
                      className={
                        ref.document_references.length > 0
                          ? styles.annotationCountContainer
                          : styles.emptyAnnotationCountContainer
                      }
                    >
                      <span className={styles.annotationCount}>
                        {`Annotation usage: ${ref.document_references.length} times`}
                      </span>
                      <div className={styles.descriptionBoxContainer}>
                        <div className={styles.descriptionBox}>
                          <img
                            className={styles.descriptionBoxImage}
                            src={dimpleSVGBlue}
                          />
                          <div className={styles.descriptionText}>
                            {"Number of times this annotation is linked"}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={styles.dividerContainer} />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      );
    }
  };

  render() {
    const { getFieldError, getFieldDecorator } = this.props.form;

    const annotationLayersDropDown = ({ onClick }) => {
      return (
        <div
          className={styles.annotaionLayersDropDownContainer}
          onClick={onClick}
        >
          <UikButton className={styles.exportButton}>
            <img className={styles.layersIcon} src={AnnotationLayersIcon} />
            Annotations
          </UikButton>
        </div>
      );
    };

    const actionsDropDown = ({ onClick }) => {
      return (
        <div
          className={styles.referenceActionsDropDownContainer}
          onClick={onClick}
        >
          &#9679;&#9679;&#9679;
        </div>
      );
    };
    return (
      <div className={styles.referenceViewer}>
        <div
          className={
            this.state.chatsPanelOpen
              ? styles.referenceDocumentContainerHalf
              : styles.referenceDocumentContainer
          }
        >
          <div className={styles.headerContainer}>
            <div className={styles.header}>
              {this.props.match.params.blockIdentifier
                ? "Reference"
                : "Select reference source"}
            </div>
            <div className={styles.titleDescriptionContainer}>
              <div className={styles.documentTitle}>
                {this.state.document && this.state.document.title}
              </div>
              <div className={styles.rightContainer}>
                <button
                  className={styles.askPaigeButton}
                  onClick={this.openChatsPanel}
                >
                  <img src={chatIcon} alt="" />
                  <span>Ask Paige</span>
                </button>
                <UikDropdown
                  DisplayComponent={annotationLayersDropDown}
                  position="bottomRight"
                >
                  <UikDropdownItem>
                    <UikToggle
                      disabled={false}
                      defaultChecked={true}
                      checked={!this.state.hideOutsideAnnots}
                      onChange={() => this.hideOutsideAnnotations()}
                    />
                    Imported Annotations
                  </UikDropdownItem>
                  <UikDropdownItem>
                    <UikToggle
                      disabled={false}
                      defaultChecked={true}
                      checked={!this.state.hideReferenceAnnotations}
                      onChange={() => this.hideReferenceAnnots()}
                    />
                    References
                  </UikDropdownItem>
                </UikDropdown>
                <div className={styles.documentDescription}>
                  <img
                    onClick={() =>
                      this.setState({
                        showDescription: !this.state.showDescription,
                      })
                    }
                    src={
                      this.state.showDescription
                        ? activeTooltipSVG
                        : defaultTooltipSVG
                    }
                  />
                  {this.state.showDescription && (
                    <div className={styles.documentDescriptionBox}>
                      <img src={dimpleSVG} />
                      <div className={styles.documentDescriptionText}>
                        {this.state.document.description
                          ? this.state.document.description
                          : "No description exists for this reference."}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {this.state.document.id &&
            this.state.references &&
            !this.state.document.not_pdftron && (
              <div className={styles.referenceContainer}>
                <PDFTReference
                  doc={this.state.document}
                  docId={this.state.document.id}
                  docExtension={this.state.document.file_extension}
                  onTextSelection={this.onTextSelection}
                  onAnnotationSelect={this.onAnnotationSelect}
                  onAnnotationDeselect={this.onAnnotationDeselect}
                  onAddReference={this.onAddReference}
                  showRenameModal={() =>
                    this.setState({ showRenameModal: true })
                  }
                  showDeleteModal={() =>
                    this.setState({ showDeleteModal: true })
                  }
                  downloadDocument={this.handleDownload}
                  xfdfHightlightId={this.props.match.params.blockIdentifier}
                  references={this.state.references}
                  onUpdateReferenceLabel={this.onUpdateReferenceLabel}
                  sharedReferences={this.state.sharedReferences}
                  approved={
                    this.props.location.state &&
                    this.props.location.state.isApproved
                  }
                  readOnly={
                    this.props.location.state &&
                    this.props.location.state.readOnly
                  }
                  currentRefLabel={this.state.currentRefLabel}
                  referenceDocumentLabel={this.state.referenceDocumentLabel}
                  linkingReference={
                    this.props.location.state
                      ? this.props.location.state.linkingReference
                      : null
                  }
                  hideOutsideAnnotations={this.state.hideOutsideAnnots}
                  hideReferenceAnnotations={this.state.hideReferenceAnnotations}
                />
              </div>
            )}
        </div>
        <div className={styles.sideBarContainer}>
          <div className={styles.sidebarHeader}>
            <div className={styles.container}>
              <div className={styles.closeButton}></div>
            </div>
            <div className={styles.searchInput}>
              <UikInput
                placeholder="Search Annotations"
                className={styles.searchInputField}
                onChange={this.onSearchChange}
                value={this.state.searchValue}
              ></UikInput>
            </div>
          </div>
          <div className={styles.referencesContainer}>
            {this.renderReferencesList()}
          </div>
          <div className={styles.doneReferenceButton}>
            <Button original text="Done" onClick={this.onCancelReference} />
          </div>
        </div>
        <Modal
          type="regular"
          hideModal={() => this.setState({ showRenameModal: false })}
          visible={this.state.showRenameModal}
        >
          <div className="heading">Rename reference</div>
          <UikDivider />
          <div className="body">
            <div className={styles.modalTitleLabel}>Title</div>
            <input
              value={this.state.documentTitleInputValue}
              onChange={(e) =>
                this.setState({ documentTitleInputValue: e.target.value })
              }
              className={styles.titleModalInput}
            />
            <div className={styles.modalDescriptionLabel}>Description</div>
            <textarea
              value={this.state.documentDescriptionInputValue}
              onChange={(e) =>
                this.setState({ documentDescriptionInputValue: e.target.value })
              }
              className={styles.descriptionModalInput}
            />
          </div>
          <UikDivider />
          <div className="buttons">
            <Button onClick={this.onRenameSave} text="Save" original />
            <Button
              onClick={() => this.setState({ showRenameModal: false })}
              text="Cancel"
              transparent
            />
          </div>
        </Modal>
        <Modal
          type="alert"
          hideModal={() => this.setState({ showDeleteModal: false })}
          visible={this.state.showDeleteModal}
        >
          <div className="heading">
            {this.state.references && this.state.references.length
              ? "Reference document can't be deleted"
              : "Confirm delete"}
          </div>
          <UikDivider />
          <div className="body">
            <div className={styles.deleteReferenceModalBody}>
              {this.state.references && this.state.references.length
                ? "This reference document cannot be deleted because it is being used by other documents."
                : "Are you sure you want to delete this annotation?"}
            </div>
          </div>
          <UikDivider />
          {this.state.references && this.state.references.length ? (
            <div className="buttons">
              <Button
                onClick={() => this.setState({ showDeleteModal: false })}
                text="OK"
                original
              />
            </div>
          ) : (
            <div className="buttons">
              <Button onClick={this.deleteReference} text="Delete" original />
              <Button
                onClick={() => this.setState({ showDeleteModal: false })}
                text="Cancel"
                transparent
              />
            </div>
          )}
        </Modal>
        <NewModal visible={this.state.tracingReference} type="alert">
          <div className="heading">Documents Containing this Annotation</div>
          <UikDivider />
          <div className="body">
            {this.state.tracingReference &&
              this.state.tracedReferenceId &&
              this.renderLinkedAnnotationsList()}
          </div>
          <UikDivider />
          <div className="buttons">
            <UikButton
              onClick={() => {
                this.stopTracingReference();
              }}
            >
              Cancel
            </UikButton>
          </div>
        </NewModal>

        <CSSTransition
          in={this.state.chatsPanelOpen}
          timeout={300}
          classNames="slide"
          unmountOnExit
        >
          <Chats
            docId={this.props.match.params.id}
            closePanel={this.closeChatsPanel}
            currentSessionId={this.state.currentChatSessionId}
            onSessionChange={this.handleChatSessionChange}
            onCitationClick={this.handleChatCitationClick}
            paigeStatus={this.state.document.paige_status}
            onPaigeStatusChange={this.handlePaigeStatusChange}
          />
        </CSSTransition>
      </div>
    );
  }
}

const ReferenceViewer = createForm()(ReferenceViewerBuild);
export default ReferenceViewer;
